<template>
  <div class="box-personal">
    <div class="form-row">
      <div
        class="
          col-12
          d-flex
          align-items-center
          flex-wrap
          mb-3
          flex-column flex-sm-row
        "
      >
        <div>
          <h2 class="d-block mini">Cadastro de Perfil</h2>
          <h5 class="">DADOS PESSOAIS</h5>
        </div>

        <button
          type="button"
          class="btn btn-white ml-0 ml-sm-auto"
          v-if="
            !$store.getters.basicProfileEmpty ||
            ($route.name != 'deixe-seu-perfil' &&
              $route.name != 'atualizacao-perfil')
          "
          @click="edit()"
        >
          <EditIcon class="h2 my-1" />
        </button>
      </div>

      <div
        class="row"
        v-if="
          !$store.getters.basicProfileEmpty || $route.name != 'deixe-seu-perfil'
        "
      >
        <div class="d-flex flex-wrap">
          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.pronoun &&
              $store.state.domains.pronouns.some(
                (p) => p.id == personal_data.pronoun
              )
            "
          >
            <h6 class="text-muted semi-small">Pronome</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.pronouns.find(
                  (gend) => gend.id == personal_data.pronoun
                )["description"]
              }}
            </p>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-4">
            <h6 class="text-muted semi-small">Nome</h6>
            <p class="text-dark h5 font-weight-bold">
              {{ personal_data.firstname }} {{ personal_data.lastname }}
            </p>
          </div>

          <div
            v-if="personal_data.socialName"
            class="col-12 col-sm-6 col-md-4 mb-4"
          >
            <h6 class="text-muted semi-small">Nome Social</h6>
            <p class="text-dark h5 font-weight-bold">
              {{ personal_data.socialName }}
            </p>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-4">
            <h6 class="text-muted semi-small">E-mail</h6>
            <p
              class="text-dark h5 font-weight-bold"
              style="max-width: 100%; overflow: hidden; text-overflow: ellipsis"
            >
              {{ personal_data.email }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="personal_data.phone && !isNaN(personal_data.phone)"
          >
            <h6 class="text-muted semi-small">Telefone</h6>
            <input
              type="tel"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :value="personal_data.phone"
              readonly
              class="text-dark h5 font-weight-bold border-0 p-0"
            />
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.raceAndEthnicity &&
              $store.state.domains.race_and_ethnicities.some(
                (r) => r.id == personal_data.raceAndEthnicity
              )
            "
          >
            <h6 class="text-muted semi-small">Cor/Raça</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.race_and_ethnicities.find(
                  (race) => race.id == personal_data.raceAndEthnicity
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.gender &&
              $store.state.domains.genders.some(
                (g) => g.id == personal_data.gender
              )
            "
          >
            <h6 class="text-muted semi-small">Gênero</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.genders.find(
                  (gend) => gend.id == personal_data.gender
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.sexualOrientation &&
              $store.state.domains.sexual_orientations.some(
                (s) => s.id == personal_data.sexualOrientation
              )
            "
          >
            <h6 class="text-muted semi-small">Orientação Sexual</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.sexual_orientations.find(
                  (gend) => gend.id == personal_data.sexualOrientation
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="personal_data.birthday"
          >
            <h6 class="text-muted semi-small">Data de Nascimento</h6>
            <p class="text-dark h5 font-weight-bold">
              {{ $moment(personal_data.birthday).format("DD/MM/YYYY") }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="personal_data.nationality"
          >
            <h6 class="text-muted semi-small">Nacionalidade</h6>
            <p class="text-dark h5 font-weight-bold">
              {{ personal_data.nationality }}
            </p>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-4" v-if="personal_data.cpf">
            <h6 class="text-muted semi-small">CPF</h6>
            <input
              type="tel"
              v-mask="'###.###.###-##'"
              :value="personal_data.cpf"
              readonly
              class="text-dark h5 font-weight-bold border-0 p-0"
              style="width: 140px"
            />
          </div>
          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="personal_data.passport"
          >
            <h6 class="text-muted semi-small">RNE</h6>
            <input
              type="tel"
              :value="personal_data.passport"
              readonly
              class="text-dark h5 font-weight-bold border-0 p-0"
            />
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.personalIncome &&
              $store.state.domains.personal_incomes.some(
                (p) => p.id == personal_data.personalIncome
              )
            "
          >
            <h6 class="text-muted semi-small">Renda Mensal</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.personal_incomes.find(
                  (gend) => gend.id == personal_data.personalIncome
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.familyIncome &&
              $store.state.domains.family_incomes.some(
                (f) => f.id == personal_data.familyIncome
              )
            "
          >
            <h6 class="text-muted semi-small">Renda Familiar</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.family_incomes.find(
                  (gend) => gend.id == personal_data.familyIncome
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-if="
              personal_data.maritalStatus &&
              $store.state.domains.maritalStatus.some(
                (m) => m.id == personal_data.maritalStatus
              )
            "
          >
            <h6 class="text-muted semi-small">Estado Civíl</h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                $store.state.domains.maritalStatus.find(
                  (status) => status.id == personal_data.maritalStatus
                )["description"]
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 mb-4"
            v-b-tooltip.hover.top="
              personal_data.descriptionHelpSelectionProcess
            "
          >
            <h6 class="text-muted semi-small deficiencia-campo">
              Portador de Deficiência
            </h6>
            <p class="text-dark h5 font-weight-bold">
              {{
                personal_data.disabilities.length == 0
                  ? "Não"
                  : personal_data.disabilities
                      .map((disab) => disab.name)
                      .join(", ")
              }}
            </p>
          </div>

          <div
            class="col-12 col-sm-6 col-md-auto mb-4"
            v-if="personal_data.location"
          >
            <h6 class="text-muted semi-small">Endereço</h6>
            <p class="text-dark h5 font-weight-bold">
              <span v-if="personal_data.location.street">{{
                personal_data.location.street
              }}</span>
              <span v-if="personal_data.location.number"
                >, {{ personal_data.location.number }}</span
              >
              <span v-if="personal_data.location.complement"
                >, {{ personal_data.location.complement }}</span
              >
              <span v-if="personal_data.location.neighborhood"
                >, {{ personal_data.location.neighborhood }}</span
              >
              <span v-if="personal_data.location.city"
                >, <br />
                {{ $helpers.toTitle(personal_data.location.city) }}
              </span>
              <span v-if="personal_data.location.stateId">
                -
                {{
                  $store.state.domains.states.find(
                    (st) => st.id == personal_data.location.stateId
                  )["abbr"]
                }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="modal-personal-data"
      size="lg"
      centered
      :hide-header="true"
      :hide-footer="true"
      no-close-on-backdrop
      lazy
    >
      <div class="py-4 px-2 px-lg-4">
        <h4 class="text-color-1 mb-4">DADOS PESSOAIS</h4>

        <button
          type="button"
          class="ml-auto close"
          @click="$refs['modal-personal-data'].hide()"
        >
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <FormPersonalData
          @closeModal="$refs['modal-personal-data'].hide()"
          hasButtons
        />
      </div>
    </b-modal>

    <div
      v-if="
        format == 'inline-form' &&
        $store.getters.basicProfileEmpty &&
        $route.name == 'deixe-seu-perfil'
      "
    >
      <div class="form-area">
        <FormPersonalData storeByEventBus />
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";
import FormPersonalData from "@/components/subscription/PersonalData/FormPersonalData.vue";
import EditIcon from "@/components/mlIcons/Edit";
export default {
  name: "BoxPersonalData",
  computed: {
    personal_data() {
      return this.$store.state.user.profile || {};
    },
    empty_profile() {
      return (
        !this.personal_data.firstname ||
        this.personal_data.firstname.length == 0 ||
        !this.personal_data.lastname ||
        this.personal_data.lastname.length == 0 ||
        !this.personal_data.socialName ||
        this.personal_data.socialName.length == 0 ||
        !this.personal_data.email ||
        this.personal_data.email.length == 0 ||
        !this.personal_data.nationality ||
        this.personal_data.nationality.length == 0 ||
        ((!this.personal_data.cpf || this.personal_data.cpf.length == 0) &&
          (!this.personal_data.passport ||
            this.personal_data.passport.length == 0)) ||
        !this.personal_data.phone ||
        this.personal_data.phone.length == 0 ||
        !this.personal_data.birthday ||
        this.personal_data.birthday.length == 0 ||
        !this.personal_data.gender ||
        this.personal_data.gender.length == 0 ||
        !this.personal_data.pronoun ||
        this.personal_data.pronoun.length == 0 ||
        !this.personal_data.raceAndEthnicity ||
        this.personal_data.raceAndEthnicity.length == 0 ||
        !this.personal_data.personalIncome ||
        this.personal_data.personalIncome.length == 0 ||
        !this.personal_data.familyIncome ||
        this.personal_data.familyIncome.length == 0 ||
        !this.personal_data.descriptionHelpSelectionProcess ||
        this.personal_data.descriptionHelpSelectionProcess.length == 0 ||
        !this.personal_data.location.zipcode ||
        this.personal_data.location.zipcode.length == 0 ||
        !this.personal_data.location.street ||
        this.personal_data.location.street.length == 0 ||
        !this.personal_data.location.number ||
        this.personal_data.location.number.length == 0 ||
        !this.personal_data.location.neighborhood ||
        this.personal_data.location.neighborhood.length == 0 ||
        !this.personal_data.location.city ||
        this.personal_data.location.city.length == 0 ||
        !this.personal_data.location.stateId ||
        this.personal_data.location.stateId.length == 0
      );
    },
  },
  props: {
    format: {
      type: String,
      default: "inline-form",
    },
  },
  components: {
    CloseIcon,
    FormPersonalData,
    EditIcon,
  },
  mounted() {
    this.$EventBus.$on("show-modal-personal-data", () => {
      this.edit();
    });
  },
  methods: {
    edit() {
      this.$refs["modal-personal-data"].show();
      setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.box-personal {
  color: #000 !important;
  h2 {
    margin-bottom: 3rem;
  }
  h6 {
    color: #000 !important;
    font-size: 1.1rem;
    font-weight: 400;
  }
}
</style>